export const prepareAdvancementConfigForSave = (config) => {
  return {
    advancementEnabled: Boolean(config.advancementEnabled ?? true),
    maxAdvancementAmount: config.maxAdvancementAmount
      ? parseFloat(config.maxAdvancementAmount)
      : null,
    maxAdvancementPercentOfSalary: config.maxAdvancementPercentOfSalary
      ? parseFloat(config.maxAdvancementPercentOfSalary)
      : null,
    minMonthsOfService: config.minMonthsOfService
      ? parseInt(config.minMonthsOfService)
      : null,
    maxActiveAdvancements: config.maxActiveAdvancements
      ? parseInt(config.maxActiveAdvancements)
      : null,
    maxAdvancementsPerMonth: config.maxAdvancementsPerMonth
      ? parseInt(config.maxAdvancementsPerMonth)
      : null,
    maxMonthlyAdvancementTotal: config.maxMonthlyAdvancementTotal
      ? parseFloat(config.maxMonthlyAdvancementTotal)
      : null,
    defaultInstallments: config.defaultInstallments
      ? parseInt(config.defaultInstallments)
      : null,
    minInstallments: config.minInstallments
      ? parseInt(config.minInstallments)
      : null,
    maxInstallments: config.maxInstallments
      ? parseInt(config.maxInstallments)
      : null,
    requireManagerApproval: Boolean(config.requireManagerApproval ?? true),
    requireHRApproval: Boolean(config.requireHRApproval ?? true),
    autoApproveUnderAmount: config.autoApproveUnderAmount
      ? parseFloat(config.autoApproveUnderAmount)
      : null,
    advancementProcessingDays: config.advancementProcessingDays
      ? parseInt(config.advancementProcessingDays)
      : null,
    allowEmergencyAdvancements: Boolean(
      config.allowEmergencyAdvancements ?? true
    ),
    emergencyMaxAmount: config.emergencyMaxAmount
      ? parseFloat(config.emergencyMaxAmount)
      : null,
    deductionStartDelay: config.deductionStartDelay
      ? parseInt(config.deductionStartDelay)
      : null,
    blockAdvancementIfPending: Boolean(
      config.blockAdvancementIfPending ?? true
    ),
    blockAdvancementIfOverdue: Boolean(
      config.blockAdvancementIfOverdue ?? true
    ),
    advancementNotifications: Boolean(
      config.advancementNotifications ?? true
    ),
  };
};